'use client';

import React, { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DEFAULT_COUNTRY_CODE } from '@/constants';
import {
  setContactUpdateErrorMessage,
  setIsAccessDenied,
  setOtpVerificationLocked,
} from '@/redux/reducers/my-profile-reducer';
import { cn } from '@/utils/cn';
import Icon from '../Icon';
import Text from '../Text';
import ImageComponentV2 from '../Image/ImageComponentV2';

function PhoneNumberInput({
  isInputBoxClicked,
  setIsInputBoxClicked,
  setPhone,
  onEnterPress,
  onBlur,
  phone,
  handleClearMouseDown,
  handleClearMouseUp,
}) {
  const inputRef = useRef(null);
  const clearingRef = useRef(null);
  const dispatch = useDispatch();

  const { contactUpdateErrorMessage } = useSelector((state) => state.myProfile);

  const handlePhoneChange = (e) => {
    setIsInputBoxClicked(true);
    dispatch(setOtpVerificationLocked(false));
    dispatch(setContactUpdateErrorMessage(''));
    dispatch(setIsAccessDenied(false));
    const value = String(e.target.value.trim()).replace(/([^+0-9]+)/gi, '');
    setPhone(value);
  };

  return (
    <div className="relative w-full">
      <div
        className={cn(
          'flex flex-row items-center justify-center pl-8  rounded-[4px] overflow-hidden relative border !border-supreme-grey',
          { 'border !border-coarse-wool': isInputBoxClicked },
          { 'border !border-infrared-burn': contactUpdateErrorMessage },
        )}
      >
        <div className="flex items-center ">
          <ImageComponentV2
            src="/icons/bd.png"
            width={26.6}
            height={16}
            className="flex-shrink-0 rounded-[4px]"
            alt="Country Flag"
            loading="lazy"
          />
          <Text
            type="paragraph"
            className="text-14 font-semibold text-senate leading-20 ml-12 mr-8"
          >
            {DEFAULT_COUNTRY_CODE}
          </Text>
          {/* TODO: UNCOMMENT WHEN MULTIPLE COUNTRY CODE WILL BE IMPLEMENTED */}
          {/* <div className="min-w-[18px]">
            <Icon
              type="angle-down"
              width="16"
              height="16"
              color="#292524"
              className={cn('transition-all duration-200')}
            />
          </div> */}
        </div>
        <span className="text-himalayan-poppy inline-block ml-[30px] mr-4 ">
          |
        </span>
        <input
          ref={inputRef}
          type="tel"
          name="phone"
          className="text-coarse-wool block w-full px-0 py-16 text-16 font-medium leading-20 tracking-[0.32px] focus:outline-none focus:ring-0 placeholder:text-senate !placeholder:text-16 !placeholder:font-encode-sans !placeholder:font-normal"
          maxLength={10}
          placeholder="1xxxxxxxxx"
          value={phone}
          onFocus={() => setIsInputBoxClicked(true)}
          onChange={handlePhoneChange}
          onKeyUp={onEnterPress}
          onKeyDown={(e) =>
            ['e', 'E', '+', '-', '.'].includes(e.key) && e.preventDefault()
          }
          onBlur={() => {
            if (clearingRef.current) {
              clearingRef.current = false;
              return;
            }
            onBlur();
          }}
        />
        {phone?.length ? (
          <div className="p-8 cursor-pointer">
            <Icon
              type={
                !isInputBoxClicked && contactUpdateErrorMessage
                  ? 'info-error'
                  : 'close'
              }
              height="24"
              width="24"
              color={
                !isInputBoxClicked && contactUpdateErrorMessage
                  ? '#DE3730'
                  : '#49525E'
              }
              onMouseDown={handleClearMouseDown}
              onMouseUp={handleClearMouseUp}
            />
          </div>
        ) : null}
      </div>
      <label
        htmlFor="phone"
        className={`absolute top-[17px] left-3 text-14 font-medium leading-20 tracking-[0.28px] text-senate bg-white duration-300 transform -translate-y-6 px-[6px] ${
          contactUpdateErrorMessage ? '!text-infrared-burn' : 'text-senate'
        }`}
      >
        Phone number
      </label>
    </div>
  );
}

export default PhoneNumberInput;
